import { createAsyncThunk } from "@reduxjs/toolkit";


const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * fetch all Faqs entries
 */
export const fetchFaqsItems = createAsyncThunk(
  "faqs/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/faqs`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY
      }
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);